module.exports = __webpack_public_path__ + "img/burbuja.02290444.webp";